module.exports = __webpack_public_path__ + "media/images/proof_links/colored/okko-ba16f1fd59df728667a22a2c001fd148.svg";